/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_To_Save_ConversationInputs */

const en_signin_to_save_conversation = /** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You'll be asked to sign in to keep your conversation history safe.`)
};

const es_signin_to_save_conversation = /** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se te pedirá que inicies sesión para mantener tu historial seguro.`)
};

const fr_signin_to_save_conversation = /** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il vous sera demandé de vous connecter pour conserver l'historique de votre conversation en toute sécurité.`)
};

const de_signin_to_save_conversation = /** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du wirst aufgefordert, dich anzumelden, um deinen Chat-Verlauf sicher aufzubewahren.`)
};

const id_signin_to_save_conversation = /** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda akan diminta untuk masuk guna menjaga riwayat percakapan Anda tetap aman.`)
};

/** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */
const ja_signin_to_save_conversation = en_signin_to_save_conversation;

/** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */
const zh_signin_to_save_conversation = en_signin_to_save_conversation;

/** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */
const ar_signin_to_save_conversation = en_signin_to_save_conversation;

/** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */
const it_signin_to_save_conversation = en_signin_to_save_conversation;

/** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */
const ru_signin_to_save_conversation = en_signin_to_save_conversation;

/** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */
const pt_signin_to_save_conversation = en_signin_to_save_conversation;

/** @type {(inputs: Signin_To_Save_ConversationInputs) => LocalizedString} */
const ko_signin_to_save_conversation = en_signin_to_save_conversation;

/**
* | output |
* | --- |
* | "You'll be asked to sign in to keep your conversation history safe." |
*
* @param {Signin_To_Save_ConversationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const signin_to_save_conversation = /** @type {((inputs?: Signin_To_Save_ConversationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_To_Save_ConversationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signin_to_save_conversation(inputs)
	if (locale === "es") return es_signin_to_save_conversation(inputs)
	if (locale === "fr") return fr_signin_to_save_conversation(inputs)
	if (locale === "de") return de_signin_to_save_conversation(inputs)
	if (locale === "ja") return ja_signin_to_save_conversation(inputs)
	if (locale === "zh") return zh_signin_to_save_conversation(inputs)
	if (locale === "ar") return ar_signin_to_save_conversation(inputs)
	if (locale === "id") return id_signin_to_save_conversation(inputs)
	if (locale === "it") return it_signin_to_save_conversation(inputs)
	if (locale === "ru") return ru_signin_to_save_conversation(inputs)
	if (locale === "pt") return pt_signin_to_save_conversation(inputs)
	return ko_signin_to_save_conversation(inputs)
});